module.exports = __webpack_public_path__ + "static/tijani-23c836535ebfcb47eebe432c08af1cd8.png";